import { type InferType, array, object, string } from "yup";

export const emailFormSchema = (recipientsLimit?: number) =>
  object({
    templateType: string(),
    emails: recipientsLimit
      ? array(
          object({
            address: string().email("L'email est invalide.").required("L'email est requis"),
            name: string().required("Le nom est requis"),
          })
        )
          .min(1, "Un destinataire est obligatoire.")
          .max(recipientsLimit, `Les destinataires ne peuvent être plus que ${recipientsLimit}`)
          .required()
      : array(
          object({
            address: string().email("L'email est invalide.").required("L'email est requis"),
            name: string().required("Le nom est requis"),
          })
        )
          .min(1, "Un destinataire est obligatoire.")
          .required(),
    cc: array(string().email("L'email est invalide.").required()).optional(),
    subject: string().required("Un objet est requis."),
    attachments: array(object({ _id: string().required() })),
    content: string().required("Le contenu de l'email ne peut être vide."),
  });

export type TEmailForm = InferType<ReturnType<typeof emailFormSchema>>;
